import React from 'react';

export default function Wishlist() {
  const wishlists = [
    {
      title: 'My Personal Wishlist',
      description: "This is a general list of items I'm interested in. Thank you for thinking of me!",
      buttonText: 'View on Amazon',
      buttonLink: 'https://www.amazon.com/hz/wishlist/ls/1XQVJ1PID9ZOU?ref_=wl_share',
      buttonBg: 'bg-indigo-600 hover:bg-indigo-700',
    },
    {
      title: "Rayyaan's Education Fund",
      description: "You can contribute to Rayyaan's 529 college savings plan through Ugift. Thank you for investing in his future!",
      ugiftCode: '83D-J2N',
      buttonText: 'Go to Ugift529.com',
      buttonLink: 'https://www.ugift529.com/',
      buttonBg: 'bg-blue-600 hover:bg-blue-700',
    },
    {
      title: "Baby Girl's Registry",
      description: "We're so excited for our baby girl's arrival! Your support means the world to us. (Due: Nov. 2025)",
      buttonText: 'View Baby Registry on Amazon',
      buttonLink: 'https://www.amazon.com/baby-reg/sunny-rija-jamil-november-2025-whiteplains/2KLL3ZKW1R90Y',
      buttonBg: 'bg-pink-500 hover:bg-pink-600',
    },
  ];

  return (
    <main className="bg-gray-50 py-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900">Wishlists</h1>
          <p className="mt-4 text-lg text-gray-600">A collection of gift ideas and registries.</p>
        </div>

        {/* Wishlist Container */}
        <div className="space-y-8">
          {wishlists.map((item, idx) => (
            <div key={idx} className="bg-white rounded-lg shadow-md overflow-hidden p-6">
              <h2 className="text-2xl font-semibold text-gray-800 mb-2">{item.title}</h2>
              <p className="text-gray-600 mb-4">{item.description}</p>
              {item.ugiftCode && (
                <p className="text-gray-800 font-semibold mb-4">
                  Ugift Code:{' '}
                  <span className="font-mono bg-gray-200 text-gray-800 py-1 px-2 rounded">
                    {item.ugiftCode}
                  </span>
                </p>
              )}
              <a
                href={item.buttonLink}
                target="_blank"
                rel="noreferrer"
                className={`inline-block text-white font-semibold py-2 px-6 rounded-lg shadow-md transition-all duration-300 ${item.buttonBg}`}
              >
                {item.buttonText}
              </a>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
